import React from 'react';
import { arrivalLineColor, closureLineColor } from '../../../constants/colors';
import AdmCumulativeChartWrapper from '../adm_shared/AdmCumulativeChartWrapper';

export default function AdmCumulativeChart(props) {
  const { arrival, closure, increment, d0_interval, d2_interval } = props;

  return (
    <AdmCumulativeChartWrapper
      title='Cumulative Defect Prediction'
      arrival={arrival}
      closure={closure}
      increment={increment}
      d0_interval={d0_interval}
      d2_interval={d2_interval}
      arrivalColor={arrivalLineColor}
      closureColor={closureLineColor}
      showArrival={true}
      showClosure={true}
    />
  );
}
